import React, { useRef, useState, useEffect } from 'react';
import {
    Tooltip,
    TooltipTrigger,
    TooltipContent,
  } from "@focal/ui-kit";
interface OverflowTooltipProps {
  children?: React.ReactNode;
  content: React.ReactNode;
  side: "top" | "right" | "bottom" | "left";
  delayDuration?: number;
}

const OverflowTooltip = ({ children, content, side, delayDuration}: OverflowTooltipProps) => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const element = textRef.current;
    if (element) {
      // Check if scrollWidth (total width of content) is greater than clientWidth (visible width)
      const overflowed = element.scrollWidth > element.clientWidth;
      setIsOverflowed(overflowed);
    }
  }, [children]); // Re-run check if the children (text content) changes

  // Helper function to handle window resize and re-check overflow
  useEffect(() => {
    const handleResize = () => {
      const element = textRef.current;
      if (element) {
        const overflowed = element.scrollWidth > element.clientWidth;
        setIsOverflowed(overflowed);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Use asChild to pass the ref to the actual DOM element
  return isOverflowed ? <Tooltip delayDuration={delayDuration}>
            <TooltipTrigger asChild>
              <span
                ref={textRef}
                className="block truncate min-w-0"
              >
                {children}
              </span>
            </TooltipTrigger>
              <TooltipContent side={side}>
                {content}
              </TooltipContent>
        </Tooltip>
      :<span ref={textRef} className="block truncate min-w-0">{children}</span>;
};

export default OverflowTooltip;
